<!--
 * @Author: wuhao
 * @Date: 2020-11-13 11:37:01
 * @LastEditors: wuhao
 * @LastEditTime: 2021-11-12 15:44:38
 * @Description: 封装select
-->
<template>
  <el-select
    :value="value"
    :placeholder="placeholder"
    :clearable="clearable"
    :filterable="filterable"
    :multiple="multiple"
    :value-key="valueKey"
    :allow-create="allowCreate"
    :popper-class="popperClass"
    :reserve-keyword="reserveKeyword"
    :default-first-option="defaultFirstOption"
    :automatic-dropdown="automaticDropdown"
    :collapse-tags="collapseTags"
    :multiple-limit="multipleLimit"
    :disabled="disabled"
    :loading="loading"
    :remote="remote"
    :remote-method="remoteMethod"
    :class="{ 'apex-remote-select': remote }"
    v-bind="$attrs"
    @change="onChange"
    @clear="onClear"
    v-on="$listeners"
  >
    <el-option
      v-for="(item, index) in innerOptions"
      :key="getOptionsKey(item, index)"
      :label="item[props.label]"
      :value="item[props.value]"
      :disabled="item[props.disabled]"
    >
      <slot />
    </el-option>
  </el-select>
</template>

<script>
import { t } from '@/locale'
import _clone from 'lodash.clone'

export default {
  name: 'ApexSelect',
  props: {
    value: {
      type: [String, Number, Boolean, Array],
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object,
      default: () => {
        return {
          key: '',
          label: 'label',
          value: 'value'
        }
      }
    },
    placeholder: {
      type: String,
      default() {
        return t('select.placeholder')
      }
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    remote: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    multipleLimit: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    localFilter: {
      type: [Boolean, Object],
      default: false
    },
    remoteConfig: {
      type: Object,
      default: null
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    allowCreate: {
      type: Boolean,
      default: false
    },
    popperClass: {
      type: String,
      default: ''
    },
    reserveKeyword: {
      type: Boolean,
      default: false
    },
    defaultFirstOption: {
      type: Boolean,
      default: false
    },
    automaticDropdown: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      innerOptions: []
    }
  },
  watch: {
    options: {
      handler() {
        this.handleDataChange()
      },
      deep: true
    }
  },
  mounted() {
    this.handleDataChange()
  },
  methods: {
    getOptionsKey(item, index) {
      if (this.localFilter) { // 如果为本地过滤key需要绑定value 防止选中值发生变化
        return item[this.props.key] || item.value
      }
      // return item[this.props.key] || index
    },
    handleDataChange() {
      if (this.innerOptions !== this.options) {
        this.innerOptions = _clone(this.options)
        this.isRemote()
      }
    },
    isRemote() {
      if (this.remote) {
        this.remoteMethod('')
      }
    },
    remoteMethod(val) {
      if (this.localFilter) {
        this.localFilterFn(val)
      } else {
        this.remoteFn(val)
      }
    },
    // 本地过滤大数据下拉
    localFilterFn(val) {
      const max = this.localFilter.max || 20
      this.innerOptions = this.options.filter(item => {
        return item[this.props.label] && item[this.props.label].toLowerCase().indexOf(val.toLowerCase()) > -1
      }).slice(0, max)
    },
    // 远程搜索
    remoteFn(val) {
      if (this.remoteConfig) {
        const params = Object.assign(this.remoteConfig.params || {}, { [this.remoteConfig.field]: val })
        this.loading = true
        this.remoteConfig.api(params).then(res => {
          this.loading = false
          this.innerOptions = res.data
        }).catch(() => {
          this.loading = false
        })
      } else {
        this.$emit('remoteMethod', val)
      }
    },
    onChange(val) {
      this.$emit('input', val)
    },
    onClear() {
      if (this.remote) {
        this.remoteMethod('')
      }
    }
  }
}

</script>

<style lang='scss' scoped>
.el-select {
  width: 180px;
}
.el-select.apex-remote-select {
  /deep/ .el-icon-::before {
    content: "\E6E1";
  }
  /deep/ .is-focus {
    .el-icon-:first-child {
      transform: rotateZ(0deg);
    }
  }
}
</style>
